import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { tickValues, colourPalette, metricLegend } from '../_base';
import CustomToolTip from '../_tooltip';
import { useSelector } from 'react-redux';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, item, id, metric }) => {
    if (!data || !data[0] || !data[0][0]) return <div>{SystemText('Dashboard/Widget/General/InvalidData')}</div>;
    const valuesY = data[0].reduce((a, c) => a.concat(c.data.map(d => ({ ...d, y: d.y * 100 }))), []);
    const valuesX = data[0][0].data;
    const [bottomTicks, setBottomTicks] = React.useState([]);
    const [leftTicks, setLeftTicks] = React.useState([]);
    const [leftTicksExtra, setLeftTicksExtra] = React.useState({});

    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        setBottomTicks(tickValues(valuesX, 'x', me.offsetWidth));
    }, [item.w]);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        let extra = {};
        setLeftTicks(tickValues(valuesY, 'y', me.offsetHeight, true, extra));
        setLeftTicksExtra(extra);
    }, [item.h]);

    const targetText = SystemText('Dashboard/Widgets/GoalsOverTime/Legend/Target');
    const yearText = SystemText('Dashboard/Widgets/GoalsOverTime/Legend/Year');
    const quarterText = SystemText('Dashboard/Widgets/GoalsOverTime/Legend/Quarter');
    const monthText = SystemText('Dashboard/Widgets/GoalsOverTime/Legend/Month');
    const weekText = SystemText('Dashboard/Widgets/GoalsOverTime/Legend/Week');

    const legendData = data[0].map((d, i) => ({ ...d, color: colourPalette[i % colourPalette.length] }));

    const period = JSON.parse(item.data).period;

    const dateFormat = period === 'W' ? e4Formats.week : e4Formats.monthShort;

    return (
        <ResponsiveLine
            data={data[0]}
            margin={{ top: 10, right: 130, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear' }}
            curve="monotoneX"
            axisTop={null}
            enableGridY
            colors={colourPalette}
            xFormat={x => e4Format(x, dateFormat)}
            axisBottom={{
                tickValues: bottomTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => e4Format(x, dateFormat),
                legend: period === 'W' ? weekText : period === 'M' ? monthText : period === 'Y' ? yearText : quarterText,
                legendOffset: 40,
                legendPosition: 'middle',
            }}
            axisLeft={{
                tickValues: leftTicks.map(t => t / 100),
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => Math.round(x * 100),
                legend: `${targetText} ${leftTicksExtra.suffix ?? ''}`,
                legendOffset: -50,
                legendPosition: 'middle',
            }}
            enableGridX={false}
            lineWidth={1.2}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={1}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh
            legends={[
                {
                    data: legendData,
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 16,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            tooltip={point => (
                <CustomToolTip
                    point={point}
                    legendData={data[0]}
                    yFormat={x => StringHelpers.formatMetric('P', x, user.currencySymbol)}
                />
            )}
        />
    );
};

export default Chart;
